import { __require as b } from "./_baseEach.js";
var e, a;
function E() {
  if (a) return e;
  a = 1;
  var u = b();
  function t(i, n) {
    var r = !0;
    return u(i, function(s, v, _) {
      return r = !!n(s, v, _), r;
    }), r;
  }
  return e = t, e;
}
export {
  E as __require
};
